import { render, staticRenderFns } from "./Scoresheet.vue?vue&type=template&id=9efef1f4&scoped=true&"
import script from "./Scoresheet.vue?vue&type=script&lang=js&"
export * from "./Scoresheet.vue?vue&type=script&lang=js&"
import style0 from "./Scoresheet.vue?vue&type=style&index=0&id=9efef1f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efef1f4",
  null
  
)

export default component.exports